module.exports = __webpack_public_path__ + "img/gb9459.prt.5065c01d.jpg";